import Vue from 'vue'
import Router from 'vue-router'
// import Home from "@/views/Home";
import Login from '@/views/Login' //方舟登录
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
    path: '/',
    component: Login,
    redirect: '/login'
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { title: "方舟-登录" }
  }
    // {
    //   path: '/',
    //   redirect: '/dashboard'
    // }, {
    //   path: "/",
    //   name: "Home",
    //   component: Home,
    //   children: [
    //     {
    //       path: "/dashboard",
    //       name: "Dashboard",
    //       meta: {
    //         title: '系统首页'
    //       },
    //       component: () => import("@/views/Dashboard/dashboard.vue")
    //     },
    //     {
    //       path: "/form",
    //       name: "form",
    //       meta: {
    //         title: '表单'
    //       },
    //       component: () => import("@/views/Form/index.vue")
    //     },
    //     {
    //       path: "/upload-file",
    //       name: "uploadFile",
    //       meta: {
    //         title: '文件上传'
    //       },
    //       component: () => import("@/views/Form/uploadFile/index.vue")
    //     },
    //     {
    //       path: "/tabs",
    //       name: "tabs",
    //       meta: {
    //         title: '选项卡'
    //       },
    //       component: () => import("@/views/Tabs/index.vue")
    //     }
    //   ]
    // }
  ]
})
